"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Partners() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const partners = [{
    name: "Emirates",
    label: "EMIRATES"
  }, {
    name: "Qatar",
    label: "QATAR AIRWAYS"
  }, {
    name: "Marriott",
    label: "DREAM RESORTS"
  }, {
    name: "Hilton",
    label: "HILTON"
  }, {
    name: "Beachcomber",
    label: "BEACHCOMBER"
  }, {
    name: "ClubMed",
    label: "CLUB MED"
  }];
  return <section data-section-id="3068" id="our-trusted-partners" className="bg-background text-foreground py-32 px-6 overflow-hidden">
      <div ref={ref} className="max-w-7xl mx-auto">
        {}
        <div className="flex justify-center mb-12">
          <p className="font-default text-[11px] tracking-[0.35em] uppercase text-center" style={{
          color: "var(--secondary)"
        }}>
            Our Trusted Travel Partners
          </p>
        </div>

        {}
        <div className="flex items-center justify-center gap-3 mb-16">
          <span className="inline-block w-1.5 h-1.5 rotate-45" style={{
          backgroundColor: "var(--secondary)"
        }} aria-hidden="true" />
          <div className="h-px w-full max-w-3xl" style={{
          backgroundColor: "var(--secondary)",
          opacity: 0.4
        }} />
          <span className="inline-block w-1.5 h-1.5 rotate-45" style={{
          backgroundColor: "var(--secondary)"
        }} aria-hidden="true" />
        </div>

        {}
        <div className="hidden md:flex items-center justify-between gap-10 lg:gap-16 px-4">
          {partners.map((partner, i) => <div data-index={i} key={partner.name} className="group relative flex items-center justify-center transition-all duration-[600ms] ease-out" style={{
          opacity: isVisible ? 0.4 : 0,
          transform: isVisible ? "translateY(0)" : "translateY(12px)",
          transitionDelay: `${i * 100}ms`
        }}>
              <span className="font-default text-2xl lg:text-3xl tracking-[0.2em] uppercase whitespace-nowrap transition-all duration-[600ms] ease-out group-hover:!opacity-100" style={{
            color: "var(--foreground)",
            filter: "grayscale(100%)",
            height: "32px",
            lineHeight: "32px",
            display: "inline-block"
          }}>
                {partner.label}
              </span>
              <span className="absolute inset-0 pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-[600ms] ease-out" style={{
            boxShadow: "0 0 40px 8px hsla(100, 50%, 51%, 0.25)",
            borderRadius: "var(--radius-lg)"
          }} aria-hidden="true" />
            </div>)}
        </div>

        {}
        <div className="md:hidden relative overflow-hidden">
          <div className="flex items-center gap-12 whitespace-nowrap" style={{
          animation: "urban-marquee 40s linear infinite",
          width: "max-content"
        }}>
            {[...partners, ...partners].map((partner, i) => <div data-index={i} key={`${partner.name}-${i}`} className="group relative flex items-center justify-center">
                <span className="font-default text-2xl tracking-[0.2em] uppercase whitespace-nowrap transition-all duration-[600ms] ease-out group-hover:!opacity-100" style={{
              color: "var(--foreground)",
              filter: "grayscale(100%)",
              opacity: 0.4,
              height: "32px",
              lineHeight: "32px",
              display: "inline-block"
            }}>
                  {partner.label}
                </span>
                <span className="absolute inset-0 pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-[600ms] ease-out" style={{
              boxShadow: "0 0 40px 8px hsla(100, 50%, 51%, 0.25)",
              borderRadius: "var(--radius-lg)"
            }} aria-hidden="true" />
              </div>)}
          </div>
        </div>

        {}
        <div className="flex items-center justify-center gap-3 mt-16">
          <span className="inline-block w-1.5 h-1.5 rotate-45" style={{
          backgroundColor: "var(--secondary)"
        }} aria-hidden="true" />
          <div className="h-px w-full max-w-3xl" style={{
          backgroundColor: "var(--secondary)",
          opacity: 0.4
        }} />
          <span className="inline-block w-1.5 h-1.5 rotate-45" style={{
          backgroundColor: "var(--secondary)"
        }} aria-hidden="true" />
        </div>
      </div>

      <style>{`
        @keyframes urban-marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </section>;
}